<oxygen-dialog></oxygen-dialog>

<div id="page-wrapper">
    <!--- Header -->
    <header-section></header-section>
    <!--- Page Content -->
    <div id="page-content" data-crlat="pageContent">
        <!--- Left Column -->
        <aside id="left-column">
            <left-menu data-crlat="leftColumn"></left-menu>
        </aside>
        <!--- Content -->
        <div id="content" data-uat="pageContent">
            <router-outlet></router-outlet>
            <ld-flag1></ld-flag1>
            <ld-flag2 *ngIf="user.status"></ld-flag2>
            <lazy-component moduleUri="@lazy-modules/seoStaticBlock/seo-static-block.module#SeoStaticBlockModule" />
        </div>

        <!--- Right Column -->
        @if (showRC) {
            <lazy-component moduleUri="@rightColumnModule/right-column.module#RightColumnModule" id="right-column" data-crlat="rightColumn" />
        }

        <back-to-top></back-to-top>
    </div>

    <!-- lazy-initializer-homepage component -->
    <lazy-component moduleUri="@lazy-modules-module/lazy-initializer-homepage/lazy-initializer-homepage.module#LazyInitializerHomepageModule" />

    <!-- SVG ICONS -->
    @if (initialIcons) {
        <svg-list id="iconsSprite_cmsInitial" [list]="initialIcons" [keepFill]="true"></svg-list>
    }
    @if (additionalIcons) {
        <svg-list id="iconsSprite_cmsAdditional" [list]="additionalIcons" [keepFill]="true"></svg-list>
    }

    <live-serv-iframe><!-- LiveServ integration iframe --></live-serv-iframe>
</div>

<!-- Invalid Fanprice Selections-->
@if (user.status && fanzoneHelperService.showFzIsPopup) {
    <lazy-component moduleUri="@lazy-modules-module/fanzone/fanzone-shared.module#FanzoneSharedModule" entryComponent="FanzoneIsDialogComponent" />
}

<!-- Fanzone coming back overlay -->
@if (user.status && fanzoneCbData && fanzoneCbData.length) {
    <lazy-component
        moduleUri="@lazy-modules-module/fanzone/fanzone-shared.module#FanzoneSharedModule"
        entryComponent="FanzoneCbOverlayComponent"
        [inputs]="{ fanzoneCbData: fanzoneCbData }" />
}

<!-- Quiz dialog component -->
<lazy-component moduleUri="@lazy-modules-module/quiz/quiz-dialog.module#QuizDialogModule" [inputs]="{ user: user }" />

<oxygen-notification></oxygen-notification>

<promotion-footer></promotion-footer>
